import React from 'react';
import { MenuItem, RaisedButton, SelectField } from 'material-ui';
import { Link } from 'react-router';

import ArchiveLetter from '../SingleNew/ArchiveLetter';
import HtmlContent from '../Single/HtmlContent';
import TextEditor from './TextEditor';
import Attachments from '../Single/Attachments';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { removeGazetters as _removeGazetters } from '../../../actions/gazetters';
import { removeAnnotations as _removeAnnotations } from '../../../actions/annotations';
import { UserPerms } from 'store/configureStore';
// import Trainings from '../Single/Gazetter/Trainings';
import ErrorBoundary from '../../common/ErrorBoundary';
import ToSpamButton from './ToSpamButton';

function Management({
    letter, textLetter, router, routeParams, openedAttachmentsDialog,
    originalText, removeGazetters, removeAnnotations, getLetterData, updatePostGazetters,
    toggleAttachmentsDialog, setServers, servers,
}) { 
    const changeAnnotationsServer = (e, i, value) => {
        setServers({ ...servers, annotationsServer: value });
        getLetterData();
    };

    const changeClarifiedServer = (e, i, value) => {
        setServers({ ...servers, clarifiedServer: value });
        getLetterData();
    };

    return (
        <div className='management'>
            <div className='management-children'>
                <RaisedButton
                    label='Gazetteer'
                    containerElement={<Link to={`/${routeParams.id}`} />}
                    primary
                    className="btn"
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                />
                <ErrorBoundary>
                    <ArchiveLetter router={router} />
                </ErrorBoundary>
                <ErrorBoundary>
                    <HtmlContent
                        letter={letter}
                    />
                </ErrorBoundary>
                <TextEditor 
                    textLetter={textLetter}
                    originalText={originalText}
                    removeGazetters={removeGazetters}
                    removeAnnotations={removeAnnotations}
                    getLetterData={getLetterData}
                    updatePostGazetters={updatePostGazetters}
                />
                <Attachments 
                    openedAttachmentsDialog={openedAttachmentsDialog}
                    toggleAttachmentsDialog={toggleAttachmentsDialog}
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px -10px' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                    attachments={letter.attachments}
                />
                <RaisedButton 
                    className='btn'
                    labelStyle={{ fontSize: '10px' }}
                    style={{ height: '25px', margin: '10px 10px 10px 0' }}
                    buttonStyle={{ height: '25px', lineHeight: '25px' }}
                    label='Size'
                    containerElement={<Link to={`/${routeParams.id}/size/vessel`} />}
                    primary
                />
                {
                    UserPerms.isAdmin() ?
                        <React.Fragment>
                            <SelectField
                                floatingLabelText='Annotations server'
                                className='btn'
                                value={servers.annotationsServer}
                                onChange={changeAnnotationsServer}
                                style={{ width: '155px' }}
                            >
                                <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                <MenuItem value='nata.im' primaryText='nata.im' />
                                <MenuItem value='polza' primaryText='polza' />
                                <MenuItem value='localhost' primaryText='localhost' />
                            </SelectField>

                            <SelectField
                                floatingLabelText='Clarified server'
                                className='btn'
                                value={servers.clarifiedServer}
                                onChange={changeClarifiedServer}
                                style={{ width: '110px' }}
                                autoWidth
                            >
                                <MenuItem value='standart' primaryText='api' />
                                <MenuItem value='localhost:7775' primaryText='localhost' />
                                <MenuItem value='s4.anotatr.com:7777' primaryText='s4.anotatr.com' />
                            </SelectField>
                        </React.Fragment>
                        :
                        ''
                }
                <br />
                {/* <Trainings letter={letter} /> */}
                <ToSpamButton
                    letterId={letter._id}
                    onSuccess={() => {
                        getLetterData();
                    }}
                    disabled={letter.type === 'spam'}
                />

            </div>
            <div className='subject' style={{ width: '150px' }}>SUBJECT: {letter.subject}</div>
            <div className='subject'>refNo: {letter.refNo}</div>   
        </div>
    );
}

export default connect(
    state => ({
        objUser: state.user,
        user: state.vesselOrders.user,
        isLogged: state.user.isLogged,
    }),
    dispatch => bindActionCreators({
        // postAnnotations,
        // postGazetters,
        removeGazetters: _removeGazetters,
        removeAnnotations: _removeAnnotations,
    }, dispatch),
)(Management);



// WEBPACK FOOTER //
// ./app/components/Letters/common/Management.jsx